import { Suspense, lazy } from 'react'
import { Button, Result } from 'antd'
import { Link, Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { env } from '@/config/env'
import { ROUTE_PATHS } from '@/config/app.config'

/** Context made available to every route (loaders/guards). */
export interface RouterContext {
  queryClient: QueryClient
}

// Devtools are dev-only and code-split so they never ship to prod.
const RouterDevtools = env.enableDevtools
  ? lazy(() =>
      import('@tanstack/react-router-devtools').then((m) => ({
        default: m.TanStackRouterDevtools,
      })),
    )
  : () => null

const QueryDevtools = env.enableDevtools
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then((m) => ({
        default: m.ReactQueryDevtools,
      })),
    )
  : () => null

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound,
})

function RootComponent() {
  return (
    <>
      <Outlet />
      <Suspense fallback={null}>
        <RouterDevtools position="bottom-right" />
        <QueryDevtools initialIsOpen={false} />
      </Suspense>
    </>
  )
}

function NotFound() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="This page doesn't exist."
      extra={
        <Link to={ROUTE_PATHS.root}>
          <Button type="primary">Back to home</Button>
        </Link>
      }
    />
  )
}
